import React from 'react';
import UsergroupUserRow from '../containers/UsergroupUserRow';

const UsergroupUsersTableRows = ({
  allowRemove,
  category,
  code,
  isDuplicate,
  items,
  removeUser,
}) => {
  const lastItem = items.length - 1;

  return items?.map((item, i) => (
    <UsergroupUserRow
      allowRemove={allowRemove}
      category={category}
      code={code}
      destroyStatus={item.destroyStatus}
      isDuplicate={isDuplicate}
      key={`usergroup_user_table_row_${item.uuid}`}
      lastItem={i === lastItem}
      removeUser={removeUser}
      user={item}
    />
  ));
};

export default UsergroupUsersTableRows;
